import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { useSelector } from 'react-redux';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import RenderRemarksInput from '../../../components/Inputs/RenderRemarksInput';
import { rejectTicketMilestone } from '../../../actions/service_request';
import RenderMilestones from '../components/RenderMileStones';
import { isIndividualMilestoneStatusInRange, MilestoneSubStatus } from '../TicketController';
const formName = 'reject_signoff';

export default function RejectSignOff({ ticket, milestones }) {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const [selectedMilestone, setSelectedMilestone] = useState(ticket.milestones[0].id);

    const submit = ({ processed_remark }) => {
        const payload = {};
        if (processed_remark?.value) {
            payload.rejection_remark = processed_remark.label;
            if (!processed_remark.value.startsWith('create_this_issue')) {
                payload.master_remark_id = processed_remark.value;
            }
        }
        dispatch(rejectTicketMilestone({
            ticketId: ticket.id,
            milestoneId: selectedMilestone,
            payload,
            formName: formName
        }));
    };

    const methods = useForm({ defaultValues: {}, mode: 'all' });

    return (
        <div className='p-4'>
            <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestone} setSelectedMilestones={setSelectedMilestone} agents={ticket.agents} />
            <Form
                methods={methods}
                onSubmit={submit}
                formName={formName}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
            >
                <RenderRemarksInput
                    category={"REJECTION"}
                    org_id={ticket.org_id}
                    name='processed_remark'
                    label='Remark'
                    className='w-full focus:ring-2 focus:ring-primary/20 transition-all duration-300'
                />
            </Form>
        </div>
    );
}
